<template>
  <div class="hello" >
    <el-container class="layout-container">
      <!--头部信息-->
      <el-header class="el-header" >
        <div class="title">
          <span>ARENA</span>
        </div>
      </el-header>
      <!--主体信息-->
      <el-main>
        <el-row type="flex" justify="center" align="middle">
          <div style="width: 570px">
            <p>To use ARENA, please input your email address and university/institution name</p>
            <el-form ref="form" :model="loginForm">
              <el-form-item>
                <el-input v-model="loginForm.email" placeholder="Enter emial" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="loginForm.school" placeholder="Enter university/institute" maxlength="100"></el-input>
              </el-form-item>
              
              <el-form-item>
                <el-button type="primary" @click="submitLogin">Submit</el-button>
              </el-form-item>
            </el-form>

          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>


<script>
export default {
  name: 'login',
  data() {
    return {
      loginForm: {email: "", school: ""},
      valid: false
    }
  },
  methods: {
    submitLogin() {
      // 首先判断是否填写了字段
      if(this.loginForm.email === null || this.loginForm.email.length === 0)
      {
        this.$message.error("Please complete the information.");
        return;
      }

      // 检查电子邮件的格式
      {
        let count = 0;
        for(let i=0;i<this.loginForm.email.length;i++)
        {
          let c = this.loginForm.email.charAt(i);
          if(c === '@'){
            count++;
          }
        }
        if(count === 0){
          this.$message.error("A wrong email");
          return;
        }
      }

      if(this.loginForm.school === null || this.loginForm.school.length === 0)
      {
        this.$message.error("Please complete the information.")
        return;
      }

      // 之后判断是否进行了人机验证
      // if(!this.valid)
      // {
      //   this.$message.error("Please complete the verification.")
      //   return;
      // }

      // 最终提交信息
      localStorage.setItem("email", this.loginForm.email);  // 记录在本地

      // 发送
      let formData = new FormData();
      for(let key in this.loginForm){
        formData.append(key, this.loginForm[key]);
      }
      this.$axios.post('/recordLogin', formData, {
        header: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      }).catch((error)=>{
        console.log("发送登录信息失败");
        console.log(error);
      })

      // 跳转
      this.$router.replace("/");
    },

    // 谷歌验证的回调函数
    callback() {
      this.valid = true;
    },
  },
  mounted() {
    window.callback = this.callback;
  },
  created() {
    let temp = localStorage.getItem("email");
    if (temp !== null && temp.length > 0) {
      this.$router.replace("/")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.layout-container .el-header {
  position: relative;
  background-color: #C6E2FF;
}

.layout-container .title{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
  color: #303133;
}

.el-main{
  height: 800px;
}

.el-row{
  height: 100%;
}
</style>
